import React, { useState } from "react";
import {
  Shield, Clock, Star, Users, Award, CheckCircle,
  ArrowRight, Phone, CarFront
} from "lucide-react";
import "./Intro.css";
import BookingModal from "../BookingModal";

const Intro = () => {
  const [showPopup, setShowPopup] = useState(false);

  const handleBookNow = () => {
    setShowPopup(true);
    document.body.style.overflow = "hidden";
  };

  const closePopup = () => {
    setShowPopup(false);
    document.body.style.overflow = "";
  };

  const handleCallNow = () => {
    window.location.href = "tel:+917574098964";
  };

  const features = [
    { Icon: Shield, title: "Safe & Secure", text: "Verified drivers & insured rides" },
    { Icon: Clock, title: "On-Time Service", text: "Punctuality you can count on" },
    { Icon: Star, title: "4.9 ★ Rating", text: "A customer-first experience", highlight: true },
    { Icon: Users, title: "5000+ Customers", text: "Growing every day" },
    { Icon: Award, title: "10+ Years", text: "Of trusted service" },
    { Icon: CheckCircle, title: "Customer Focused", text: "Support for your journey", highlight: true },
  ];

  return (
    <>
      <section className="intro-simple" id="intro">
        <div className="intro-simple-container">
          <div className="intro-simple-content">
            <header className="intro-simple-header">
              <span className="intro-simple-eyebrow"><span className="intro-simple-eyebrow-line" /> BHОLE CAB SERVICE · YOUR TRAVEL PARTNER</span>
              <span className="intro-simple-tag"><CarFront size={16} aria-hidden="true" /> Welcome to Bhole Cab Service</span>
              <h2 className="intro-simple-title">
                Ride with <span>Trust</span>.<br className="intro-simple-title-break" /> Travel with <span>Us.</span>
              </h2>
              <p className="intro-simple-subtitle">
                Your trusted partner for safe, comfortable, and reliable rides across India.
              </p>
              <div className="intro-simple-divider" aria-hidden="true"><span /></div>
            </header>

            <div className="intro-simple-body">
              <p className="intro-simple-text">
                Welcome to <strong>Bhole Cab Service</strong>, your trusted choice for safe, smooth and stress-free rides. Whether it's a short city ride or an outstation journey across states, we cover routes across India with professionalism and care.
              </p>
              <p className="intro-simple-text">
                We focus on timely pickups, courteous drivers, and comfortable travel. Get in touch with us to plan your journey and book a cab with confidence.
              </p>
            </div>

            <div className="intro-simple-features">
              {features.map(({ Icon, title, text, highlight }) => (
                <article className={`intro-simple-feature${highlight ? " highlight" : ""}`} key={title}>
                  <div className="intro-simple-icon"><Icon size={19} strokeWidth={1.9} /></div>
                  <div className="intro-simple-feature-copy">
                    <h3>{title}</h3>
                    <p>{text}</p>
                  </div>
                </article>
              ))}
            </div>

            <div className="intro-simple-actions">
              <button className="intro-simple-btn-primary" onClick={handleBookNow}>
                Book Your Ride <ArrowRight size={18} />
              </button>
              <button className="intro-simple-btn-secondary" onClick={handleCallNow}>
                <Phone size={17} /> Call Now
              </button>
            </div>
          </div>
        </div>
      </section>
      <BookingModal isOpen={showPopup} onClose={closePopup} />
    </>
  );
};

export default Intro;
